<ng-container *transloco="let t">
<ng-template #createAccount>
  @if (showAccountForm) {
    <div id="submitApplication">
      @if (isSubmittedInEditMode) {
        <div class="alert alert-warning d-flex align-items-center p-5 mb-10">
          <span class="svg-icon svg-icon-2hx svg-icon-warning me-4">
            <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
          </span>
          <div class="d-flex flex-column">
            <h5 class="mb-1">{{ t('wizard.createAccount.willNotSubmit') }}</h5>
            <span>{{ t('wizard.createAccount.adminEditingWarning') }}</span>
          </div>
        </div>
      }
    </div>
    @if (inEditMode) {
      <div class="d-flex mb-10">
        <div class="col-sm-3 col-form-label fw-bold fs-6 editor-label">{{ t('wizard.createAccount.userCreationAutoConfirmed') }}</div>
        <div class="col-sm-2 form-check form-switch form-check-custom form-check-solid">
          <input class="form-check-input h-20px w-30px" type="checkbox" id="userCreationAutoConfirmed" name="userCreationAutoConfirmed"
          [ngModelOptions]="{standalone: true}" [(ngModel)]="userCreationAutoConfirmed" />
          <label class="form-check-label" for="userCreationAutoConfirmed">
            {{userCreationAutoConfirmed ? t('common.yes') : t('common.no')}}
          </label>
        </div>
      </div>
    }

    <div class="row mb-5">
      @if (passwordPolicyViolations) {
        <div class="alert alert-warning d-flex align-items-center p-5 mb-10">
          <span class="svg-icon svg-icon-2hx svg-icon-warning me-4">
            <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
          </span>
          <div class="d-flex flex-column">
            <h5 class="mb-1">{{ t('wizard.createAccount.passwordPolicyViolation') }}</h5>
            <ul>
              @for (violation of passwordPolicyViolations; track violation.id) {
                <li>
                  {{violation.message}}
                </li>
              }
            </ul>
          </div>
        </div>
      }
      @if (userExists) {
        <div class="alert alert-warning d-flex align-items-center p-5 mb-10">
          <span class="svg-icon svg-icon-2hx svg-icon-warning me-4">
            <duotone-warning-circle-svg-icon></duotone-warning-circle-svg-icon>
          </span>
          <div class="d-flex flex-column">
            <h5 class="mb-1">{{ t('wizard.createAccount.userAlreadyExists') }}</h5>
            <div class="mb-2">
              {{ t('wizard.createAccount.userAlreadyRegistered', { email: step.borrower!.primaryEmail }) }}<br>
              {{ t('wizard.createAccount.pleaseClick') }} <a (click)="onLoginClicked()" class="fw-bolder me-1">{{ t('wizard.createAccount.here') }}</a>{{ t('wizard.createAccount.toLogin') }}
            </div>
          </div>
        </div>
      }
      <borrower-info [customMessage]="t('wizard.createAccount.customMessage')" [doesSetPassword]="userCreationAutoConfirmed" [borrower]="step.borrower"
        [fieldsToConfig]="step.fieldConfig">
      </borrower-info>
    </div>
    @if (step.borrower.mobilePhone || inEditMode) {
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="py-3">
            <div class="col-lg-12 fv-row">
              @if (inEditMode) {
                <label class="col-form-label fw-bold fs-6 editor-label" for="smsConsentText">{{ t('wizard.createAccount.smsConsentTextLabel') }}</label>
                <textarea id="smsConsentText" name="smsConsentText" rows="4" class="form-control form-control-solid fs-6"
                  [ngModel]="i18n.get(config, 'smsConsentText')" (ngModelChange)="i18n.set(config, 'smsConsentText', $event)"
                  [placeholder]="i18n.basePlaceholder(config, 'smsConsentText')"></textarea>
                <div class="form-text">{{ t('wizard.createAccount.smsConsentTextHint') }}</div>
              }
              <div class="d-flex align-items-center mt-3">
                <label class="form-check form-check-inline form-check-solid me-5">
                  <input class="form-check-input" name="optInForReceivingSms"
                    [(ngModel)]="optInForReceivingSms" type="checkbox" value="1" />
                  @if (customSmsConsentHtml; as customHtml) {
                    <span class="ps-2 fs-6" style="font-style:italic" [innerHTML]="customHtml"></span>
                  } @else {
                    <span class="ps-2 fs-6" style="font-style:italic">{{ t('wizard.createAccount.smsConsent') }}
                      {{ t('wizard.createAccount.privacyPolicy') }}: <a href="https://www.lodasoft.com/privacy-policy" target="_blank" rel="noopener noreferrer">https://www.lodasoft.com/privacy-policy</a>.
                      {{ t('wizard.createAccount.smsTermsAndConditions') }}: <a href="https://www.lodasoft.com/termsofservice" target="_blank" rel="noopener noreferrer">https://www.lodasoft.com/termsofservice</a>.</span>
                      @if (showReplyHelpDisclaimer) {
                        <span style="font-style:italic"> {{ t('wizard.createAccount.replyHelpForMoreInfo') }}</span>
                      }
                  }
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
  @if (isExternalAuthHandoff) {
    <div class="d-flex">
      <div class="spinner-border m-5 text-success" style="width: 2.75rem; height: 2.75rem" role="status"></div>
      <h4 style="margin-top: 24px">{{ t('common.pleaseWait') }}</h4>
    </div>
  }
</ng-template>

<wizard-step-template [stepMainTemplate]="createAccount" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
